module.exports = __webpack_public_path__ + "static/media/icon_chevron_head.7ad81ad6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Stepper/assets/icon_chevron_head.svg
// module id = 1501
// module chunks = 193